/**
 * Account settings: pure domain model.
 *
 * The signed-in user's own editable identity (first name, last name, email).
 * This is the `account` domain (the *current user's* account) and is
 * deliberately separate from the `profile` domain (the tracked HNWI/company
 * profiles the product enriches), which merely shares the English word.
 *
 * Pure and framework-free: no React, no Redux, no fetch. Depends on no other
 * feature or domain (hermeticity).
 */

/** The editable identity fields of the current account. */
export interface AccountDraft {
  firstName: string;
  lastName: string;
  email: string;
}

/** A pristine draft: the state before the account has hydrated. */
export const emptyDraft: AccountDraft = {
  firstName: '',
  lastName: '',
  email: '',
};

/** Field-keyed validation messages produced by `validateDraft`. */
export type ValidationErrors = Partial<Record<keyof AccountDraft, string>>;

/** Lifecycle of a save. */
export type SaveStatus = 'idle' | 'saving' | 'succeeded' | 'failed';
